import { render, staticRenderFns } from "./Operations.vue?vue&type=template&id=ff4167ba&scoped=true&"
import script from "./Operations.vue?vue&type=script&lang=ts&"
export * from "./Operations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4167ba",
  null
  
)

export default component.exports